"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialVentilatedWallThermalPerformanceState = exports.VENTILATED_WALL_MINIMUM_INSULATION_THICKNESS = exports.EXTENDED_VENTILATED_WALL_R_VALUE_RSE = exports.EXTENDED_VENTILATED_WALL_R_VALUE_RSI = exports.VENTILATED_WALL_R_VALUE_RSE = exports.VENTILATED_WALL_R_VALUE_RSI = void 0;
exports.VENTILATED_WALL_R_VALUE_RSI = 0.13;
exports.VENTILATED_WALL_R_VALUE_RSE = 0.04;
exports.EXTENDED_VENTILATED_WALL_R_VALUE_RSI = 0.13;
exports.EXTENDED_VENTILATED_WALL_R_VALUE_RSE = 0.04;
exports.VENTILATED_WALL_MINIMUM_INSULATION_THICKNESS = 20;
exports.initialVentilatedWallThermalPerformanceState = {
    UCValue: null,
    RTValue: null,
    wallType: {
        thickness: null,
        lambda: null,
        RValue: null,
    },
    facadeCladding: {
        thickness: null,
        lambda: null,
        RValue: null,
    },
    wallInsulation: {
        thickness: null,
        lambda: null,
        RValue: null,
    },
};
